<template>
  <div>
    <div class="comm_popup_wrap_xlarge">
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_USR_PRSNZ') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_EMPL_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ user.userName }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DEPT_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ user.departmentName }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CPNY_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ user.companyName }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_REP_SITE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ personalization.SIT }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_GBM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ personalization.GBM }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_NUM_FMT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ personalization.NFM }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TZONE_AREA')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ personalization.DIV }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TZONE_GMT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-7">
            <div class="comm_label">
              {{ personalization.TMZ }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_LANG')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ personalization.LNG }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ACC_USE_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <div class="comm_label">
              {{ user.userAccountPossessionYn }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ACC_STATUS')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-code-select
              ref="userAccountStateCode"
              :selected="userAccountStateCode"
              :pageId="pageId"
              codeId="COD_USR_ACO_STT"
              defaultOption="select"
              :disabled="disabledMod"
            />
          </div>
        </div>
      </div>
      <div class="comm_title_wrap">
        <h4> {{ $t('MSG_TXT_PSS_AUTH_LIST') }}</h4>
      </div>
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'ds0'"
        :multiselect="false"
        :showDisplayCountControl="false"
        :initial-pagesize="5"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        v-permission:read="pageId"
        type="button"
        class="comm_btn_border"
        @click="onCloseClick"
      >
        {{ $t('MSG_BTN_CLOSE') }}
      </sui-button>
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        :disabled="disabledMod"
        @click="onSaveClick"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00032_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      user: {
        userName: '',
        departmentName: '',
        companyName: '',
        userAccountPossessionYn: '',
      },
      personalization: {
        TMZ: '',
        SIT: '',
        LNG: '',
        GBM: '',
        NFM: '',
        DIV: '',
      },
      userAccountStateCode: {
        key: '',
        label: '',
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_SITE'),
        datafield: 'siteName',
      }, {
        text: this.$t('MSG_TXT_WORK_NM'),
        datafield: 'taskName',
      }, {
        text: this.$t('MSG_TXT_USER_GRP_NAME'),
        datafield: 'userGroupName',
      }, {
        text: this.$t('MSG_TXT_AUTH_APPR_STT'),
        datafield: 'authRequestStatusName',
      }],
    };
  },
  computed: {
    disabledMod() {
      return utils.isEqual(this.user.userAccountPossessionYn, 'NO');
    },
  },
  watch: {},
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.userId)) {
        this.onLoad();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      http.request(this.pageId, 'DTS_CMY_00086', {
        path: {
          'b2b-id': this.userId,
        },
      }).then(res => {
        // 사용자 정보
        utils.forEach(this.user, (value, key) => {
          this.user[key] = res.data[key];
        });

        // 개인환경설정 정보
        utils.forEach(res.data.personalizations, personalization => {
          const { personalizationTypeCode, personalizationValueName } = personalization;
          if (utils.isEqual(personalizationTypeCode, 'TMZ')) {
            this.personalization.DIV = personalization.timezoneDivName;
          }
          this.personalization[personalizationTypeCode] = personalizationValueName;
        });

        // 사용자 계정 정보
        const stateCode = this.disabledMod ? ' ' : res.data.userAccountStateCode;
        this.$refs.userAccountStateCode.select(stateCode);

        // 보유 권한 목록
        this.ds0.setRawData(res.data.auths);
      }).catch(error => {
        console.log(error);
      });
    },
    onSaveClick() {
      if (utils.isEmpty(utils.trim(this.userAccountStateCode.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_ACC_STATUS')));
        return false;
      }

      const saveData = {
        b2bId: this.userId,
        userAccountStateCode: this.userAccountStateCode.key,
      };
      http.request(this.pageId, 'DTS_CMY_00087', {
        path: {
          'b2b-id': this.userId,
        },
        data: saveData,
      }).then(() => {
        utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, this.research);
      }).catch(error => {
        console.log(error);
      });

      return true;
    },
    onCloseClick() {
      this.$emit('onDetailAndCancelClick');
    },
    research() {
      this.$emit('research');
    },
  },
  datasets: [{
    id: 'ds0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'siteName', map: 'siteName' },
      { type: 'string', name: 'taskName', map: 'taskName' },
      { type: 'string', name: 'userGroupName', map: 'userGroupName' },
      { type: 'string', name: 'authRequestStatusName', map: 'authRequestStatusName' },
    ],
  }],
};
</script>
<style scoped>
</style>
